import { createSelector } from 'reselect';
import { SelectedCustomerSelector, CurrentCustomerBillCycleSelector, CurrentCustomerNewBillCycleSelector } from './customer.selectors';
import { BillCycleHelper } from 'invision-core';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { map } from 'ramda';
export var IsRetrievingBillCycleDetailsSelector = createSelector([SelectedCustomerSelector], function (customer) {
  return customer.billCycle.isFetchingBillCycleDetails;
});
export var IsEvaluatingBillCyclesSelector = createSelector([SelectedCustomerSelector], function (customer) {
  return customer.billCycle.isEvaluatingBillCycles;
});
export var CandidateBillCyclesSelector = createSelector([SelectedCustomerSelector], function (customer) {
  return map(BillCycleHelper.addTranslatedDueDates, customer.billCycle.candidateBillCycles);
});
export var BillCycleDetailsSelector = createSelector([SelectedCustomerSelector, CurrentCustomerBillCycleSelector], function (customer, currentCustomerBillCycle) {
  if (currentCustomerBillCycle) {
    return customer.billCycle.billCycleDetails;
  } else {
    return null;
  }
});
export var NewBillCycleDetailsSelector = createImmutableSelector([SelectedCustomerSelector, CurrentCustomerNewBillCycleSelector], function (customer, currentCustomerNewBillCycle) {
  var _customer$billCycle;
  return currentCustomerNewBillCycle ? customer === null || customer === void 0 ? void 0 : (_customer$billCycle = customer.billCycle) === null || _customer$billCycle === void 0 ? void 0 : _customer$billCycle.newBillCycleDetails : null;
});
export var BillCycleDetailsLastRetrieveErrorSelector = createSelector([SelectedCustomerSelector], function (customer) {
  return customer.billCycle.lastRetrieveError;
});